import React from "react";

const ShowPassIcon = ({
  style = {},
  width = "70",
  height = "70",
  className = "",
  fill = "#7758B3",
  stroke = "#7758B3",
  viewBox = "0 0 70 70",
}) => (
 
<svg width="18" height="18" viewBox="0 0 18 18" fill="none" >
<path d="M0.75 9C0.75 9 3.891 4.5 9 4.5C9.71025 4.5 10.38 4.59 11.0085 4.7415L6.27 9.48C6.09305 9.09404 6.00098 8.67459 6 8.25C6 7.54725 6.25125 6.90975 6.65625 6.3975C4.86225 7.008 3.495 8.18775 2.715 9C3.38014 9.69248 4.13126 10.2969 4.95 10.7985L3.8625 11.8875C1.8735 10.5975 0.75 9 0.75 9ZM17.25 9C17.25 9 14.109 13.5 9 13.5C8.2905 13.5 7.623 13.407 6.993 13.2578L3.75 16.5L2.625 15.375L15.375 2.625L16.5 3.75L14.1398 6.11025C16.125 7.4025 17.25 9 17.25 9ZM15.2888 9.0045C14.6231 8.30935 13.8701 7.70354 13.0485 7.20225L12 8.25C12 9.9075 10.6575 11.25 9 11.25L8.28975 11.9602C8.52225 11.9827 8.75775 12 9 12C11.9835 12 14.2073 10.1415 15.2888 9.0045Z" fill="#8A8A8A"/>
</svg>


     
);

export default ShowPassIcon;
